import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { MapPin } from "lucide-react";
import { Reveal } from "./anim";
import { CONTACT, IMAGES } from "./config";

const cities = ["Béziers", "Agde", "Sète", "Montpellier", "Narbonne", "Pézenas", "Cap d'Agde", "Toulouse", "Marseille"];

const Zone = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section id="zone" data-testid="zone-section" ref={ref} className="relative overflow-hidden py-28 lg:py-40">
      <motion.div style={{ y }} className="absolute inset-0 -z-10">
        <img src={IMAGES.palm} alt="Coucher de soleil sur les palmiers d'Occitanie" className="h-[130%] w-full object-cover opacity-30" />
      </motion.div>
      <div className="absolute inset-0 -z-10 bg-ink/70" />

      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <Reveal>
          <p className="mb-4 flex items-center gap-2 text-xs uppercase tracking-[0.3em] text-rose">
            <MapPin size={14} /> Zone d'intervention
          </p>
          <h2 className="max-w-3xl font-serif text-4xl leading-tight tracking-tight sm:text-6xl text-blush">
            Basé à Béziers, à votre service dans tout l'Hérault et l'Occitanie.
          </h2>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="mt-12 flex flex-wrap gap-3">
            {cities.map((c) => (
              <span key={c} data-testid={`zone-city-${c}`} className="rounded-full border border-rose/30 bg-rose/5 px-5 py-2.5 text-sm text-blush/90 backdrop-blur-sm transition-colors hover:border-rose hover:bg-rose/10">
                {c}
              </span>
            ))}
          </div>
        </Reveal>

        <Reveal delay={0.2}>
          <p className="mt-10 max-w-lg text-sm leading-relaxed text-muted-foreground">
            Un déplacement en dehors de cette zone ? Contactez-nous, nous étudions toutes les demandes de trajet longue distance en France.
          </p>
        </Reveal>
      </div>
    </section>
  );
};

export default Zone;
